import type { HTMLAttributes } from "react";
import { createElement } from "react";
import { SxProps, Theme, useTheme } from "@mui/material/styles";

import { IconContainer } from "./Icon.styles";
import { SizeStyles } from "./Icon.variants";

import { Icons } from "./Icons";

export type IconName = keyof typeof Icons;

export interface IconProps extends HTMLAttributes<HTMLDivElement> {
  icon: IconName;
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
  weight?: number
  rotate?: number;
  sx?: SxProps<Theme>
}

export const Icon = ({ icon, size = "md", weight = 1, rotate, sx, color = "inherit", ...rest }: IconProps) => {
  const theme = useTheme();

  const sizeStylesFn = SizeStyles(theme);

  return (
    <IconContainer
      aria-label={icon}
      role="img"
      sx={{
        ...sizeStylesFn[size],
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
        color: {color},
        ...sx
      }}
      {...rest}
    >
      {createElement(Icons[icon], {
        style: { width: "100%", height: "100%", strokeWidth: weight },
      })}
    </IconContainer>
  );
};